// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFooter_root__156ut"};